"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOrderSchema = exports.SignInSchema = exports.UpdateAddressSchema = exports.SearchOrderSchema = void 0;
const Yup = __importStar(require("yup"));
const REQUIRED_FIELD = 'Este campo é obrigatório';
const MUST_BE_VALID_EMAIL = 'Este campo deve ser um e-mail válido';
const MUST_BE_VALID_HP = 'Este campo deve ser um HP válido';
exports.SearchOrderSchema = Yup.object({
    transaction: Yup.string().test({
        test: value => {
            const hasHP = value === null || value === void 0 ? void 0 : value.trim().startsWith('HP');
            if (!hasHP) {
                return false;
            }
            const hasNumbers = value === null || value === void 0 ? void 0 : value.trim().replace(/\D/ig, '');
            if (!(hasNumbers === null || hasNumbers === void 0 ? void 0 : hasNumbers.length)) {
                return false;
            }
            return true;
        },
        message: MUST_BE_VALID_HP
    }).required(REQUIRED_FIELD),
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD)
});
exports.UpdateAddressSchema = Yup.object({
    address_cep: Yup.string().required(REQUIRED_FIELD),
    address_street: Yup.string().required(REQUIRED_FIELD),
    address_number: Yup.string().required(REQUIRED_FIELD),
    address_neighborhood: Yup.string().required(REQUIRED_FIELD),
    address_complement: Yup.string().optional(),
    address_city: Yup.string().required(REQUIRED_FIELD),
    address_state: Yup.string().length(2, 'Deve conter apenas 2 letras').required(REQUIRED_FIELD),
    address_country: Yup.string().required(REQUIRED_FIELD),
    transaction: Yup.string().test({
        test: value => {
            const hasHP = value === null || value === void 0 ? void 0 : value.trim().startsWith('HP');
            if (!hasHP) {
                return false;
            }
            const hasNumbers = value === null || value === void 0 ? void 0 : value.trim().replace(/\D/ig, '');
            if (!(hasNumbers === null || hasNumbers === void 0 ? void 0 : hasNumbers.length)) {
                return false;
            }
            return true;
        },
        message: MUST_BE_VALID_HP
    }).required(REQUIRED_FIELD),
    buyer_email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD)
});
exports.SignInSchema = Yup.object({
    password: Yup.string().required(REQUIRED_FIELD),
});
exports.AddOrderSchema = Yup.object({
    buyer_name: Yup.string().required(REQUIRED_FIELD),
    transaction: Yup.string().test({
        test: value => {
            const hasHP = value === null || value === void 0 ? void 0 : value.trim().startsWith('HP');
            if (!hasHP) {
                return false;
            }
            const hasNumbers = value === null || value === void 0 ? void 0 : value.trim().replace(/\D/ig, '');
            if (!(hasNumbers === null || hasNumbers === void 0 ? void 0 : hasNumbers.length)) {
                return false;
            }
            return true;
        },
        message: MUST_BE_VALID_HP
    }).required(REQUIRED_FIELD),
    buyer_email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD)
});
